import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MUIListItemIcon, { ListItemIconProps } from '@material-ui/core/ListItemIcon';

function ListItemIcon({ classes, ...restOfProps }: ListItemIconProps) {
  const _classesOverride = useStyles();
  const classesOverride = !!classes ? classes : _classesOverride;

  return <MUIListItemIcon classes={classesOverride} {...restOfProps} />;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    minWidth: 'auto',
    marginRight: theme.spacing(2),
    color: 'inherit',
  },
}));

export default ListItemIcon;
